import React from 'react';

const DjangoIcon = ({ fillColor, width = "55", height = "55", ...props }) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 550.000000 550.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g
      transform="translate(0.000000,550.000000) scale(0.100000,-0.100000)"
      fill={fillColor}
      stroke="none"
    >
      <path
        d="M2528 5239 c-245 -24 -416 -64 -710 -168 -144 -50 -468 -236 -614
-353 -82 -65 -354 -335 -411 -409 -129 -164 -313 -482 -364 -627 -79 -224
-112 -341 -134 -472 -57 -344 -59 -564 -5 -890 26 -161 53 -261 117 -435 278
-757 928 -1351 1688 -1543 476 -120 809 -122 1281 -7 221 54 475 157 604 244
25 17 49 31 53 31 17 0 225 148 317 225 120 101 214 195 315 315 73 86 225
300 225 315 0 3 22 43 49 88 46 76 87 167 162 356 35 88 102 364 124 511 80
535 -50 1152 -342 1631 -293 478 -745 850 -1268 1042 -180 66 -268 90 -429
116 -243 40 -455 49 -658 30z m420 -2226 l-3 -1247 -100 -18 c-230 -40 -350
-51 -565 -52 -225 0 -308 9 -465 56 -211 62 -380 195 -464 365 -129 258 -125
640 7 899 66 129 208 271 337 336 82 42 209 84 297 98 76 12 355 9 396 -5 l22
-7 0 404 c0 223 3 408 7 411 3 4 125 7 270 7 l263 0 -2 -1247z m862 962 l0
-275 -270 0 -270 0 0 275 0 275 270 0 270 0 0 -275z m-5 -1330 c0 -590 -3
-805 -13 -884 -48 -374 -190 -600 -472 -750 l-80 -42 -158 75 c-86 41 -196 92
-244 115 -49 22 -88 43 -88 48 0 5 37 27 83 50 179 90 301 217 357 371 68 187
80 367 80 1200 l0 602 268 -2 267 -3 0 -780z"
      />
      <path
        d="M2124 3016 c-217 -50 -323 -212 -311 -476 14 -299 176 -430 502 -405
l95 7 0 428 0 428 -32 11 c-53 19 -187 22 -254 7z"
      />
    </g>
  </svg>
);

export default DjangoIcon;